import React from 'react';
import Immutable from 'immutable';
import { cx } from '@milanote/roma/utils';
import { Menu, MenuSize } from '@milanote/roma';
import { GridListItem } from 'react-aria-components';
import ListItemBoardIcon from '../../../popupPanel/listItems/ListItemBoardIcon';
import { getRootBoardProperty } from '../../../../../common/elements/utils/elementPropertyUtils';
import type { BoardLinkListBaseProps, BoardLinkSearchItem } from './boardLinkTypes';

import './BoardLinkListItem.scss';

export type BoardLinkItemProps = BoardLinkListBaseProps & {
    item: BoardLinkSearchItem;
    size?: MenuSize;
};

const BOARD_LINK_ICON_SIZE = 32;

const BoardLinkListItem: React.FC<BoardLinkItemProps> = ({ item, gridSize, onSelect, isSheet, size = 'sm' }) => {
    const isRootBoard = getRootBoardProperty(item.board);
    const boardIconSize = BOARD_LINK_ICON_SIZE / gridSize;

    return (
        <GridListItem
            id={item.boardId}
            textValue={item.title}
            onAction={() => onSelect(item)}
            className={cx('BoardLinkListItem w-full outline-hidden')}
        >
            {(state) => (
                <Menu.Base.ItemStructured
                    leading={
                        <span
                            aria-hidden="true"
                            className={cx(
                                'inline-flex shrink-0 items-center justify-center',
                                isRootBoard && 'p-0.5 [&_.MilanoteLogo_svg]:size-full!',
                            )}
                        >
                            <ListItemBoardIcon
                                element={Immutable.fromJS(item.board)}
                                size={boardIconSize}
                                gridSize={gridSize}
                            />
                        </span>
                    }
                    label={<span className="truncate text-md font-semibold text-primary">{item.title}</span>}
                    isSelected={false}
                    isDisabled={state.isDisabled}
                    isFocused={state.isFocused}
                    isFocusVisible={state.isFocusVisible}
                    isHovered={isSheet ? false : state.isHovered}
                    className="cursor-pointer px-2 py-1.5"
                    size={size}
                />
            )}
        </GridListItem>
    );
};

export default BoardLinkListItem;
